import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "swipe-carousel-container" };
import { ref, watch, onMounted, useSlots } from 'vue';
import PaginationDots from './PaginationDots.vue';
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SwipeCarousel',
    props: {
        modelValue: { default: 0 },
        height: { default: '211px' },
        showButtons: { type: Boolean, default: true },
        showArrows: { type: Boolean, default: true },
        paginationDots: { type: Boolean, default: false },
        itemCount: { default: 1 }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "75caf313": (_ctx.height)
        }));
        const { isDarkMode } = useDarkMode();
        const props = __props;
        const emit = __emit;
        const slots = useSlots();
        const currentSlide = ref(props.modelValue);
        const totalSlides = ref(props.itemCount);
        watch(() => props.modelValue, (newVal) => {
            currentSlide.value = newVal;
        });
        watch(() => props.itemCount, (newVal) => {
            totalSlides.value = newVal;
        });
        watch(currentSlide, (newVal) => {
            emit('update:modelValue', newVal);
        });
        onMounted(() => {
            const slotChildren = slots.default?.() || [];
            if (slotChildren.length === 1 && slotChildren[0].type === Symbol.for('v-fgt')) {
                totalSlides.value = props.itemCount;
            }
            else {
                totalSlides.value = slotChildren.length || props.itemCount;
            }
        });
        function handleSlideChange(newValue) {
            if (newValue < 0) {
                currentSlide.value = 0;
            }
            else if (newValue >= totalSlides.value) {
                currentSlide.value = totalSlides.value - 1;
            }
        }
        return (_ctx, _cache) => {
            const _component_v_carousel = _resolveComponent("v-carousel");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_carousel, {
                    modelValue: currentSlide.value,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((currentSlide).value = $event)),
                        handleSlideChange
                    ],
                    "show-arrows": _ctx.showArrows,
                    height: _ctx.height,
                    continuous: false,
                    "hide-delimiters": !_ctx.showButtons,
                    class: _normalizeClass(["swipe-carousel", { dark: _unref(isDarkMode) }])
                }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                }, 8, ["modelValue", "show-arrows", "height", "hide-delimiters", "class"]),
                (_ctx.paginationDots)
                    ? (_openBlock(), _createBlock(PaginationDots, {
                        key: 0,
                        "total-items": _ctx.itemCount,
                        "current-index": currentSlide.value,
                        maxDots: 5
                    }, null, 8, ["total-items", "current-index"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
